baseApp.directive('confirmpw', function() {
    return {
        templateUrl: '/public/directives/confirmpw.html',
        scope: {
            pw: "=",
            form: "=",
            labelWidth: "@",
            valid: "=?"
        },
        link:function($scope){
            $scope.confirmedPW = null;

            if(!$scope.labelWidth){
               $scope.labelWidth = 3;
            }

            $scope.$watch("pw", function() {
                $scope.valid = !$scope.pw || ($scope.pw === $scope.confirmedPW);
            });

            $scope.$watch("confirmedPW", function() {
                $scope.valid = !$scope.pw || ($scope.pw === $scope.confirmedPW);
            });

            $scope.$on('confirmpw-clearPw', function() {
                $scope.confirmedPW = null;
            });
        }
    };
});